import React from 'react';
import Typography from '@mui/material/Typography';
import { eyebrow } from './theme.js';

export function HeroBadge({ label, color, sx }) {
    return (
        <Typography component="div" sx={{ ...eyebrow, mb: 2.5, ...(color && { color }), ...sx }}>
            {label}
        </Typography>
    );
}
